import { useCallback, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
//import { MdTranslate } from "react-icons/md";
import IconNav from "../../components/nav-bar/icon-nav";
import "./g-translate.scss";

const GTranslate = ({ iconMenu }) => {
    const [isDropdownVisible, setDropdownVisible] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (!window.gtranslateSettings) {
            window.gtranslateSettings = {
                default_language: "en",
                detect_browser_language: true,
                languages: [
                    "en",
                    "es",
                    "af",
                    "sq",
                    "am",
                    "ar",
                    "hy",
                    "az",
                    "eu",
                    "be",
                    "bn",
                    "bs",
                    "bg",
                    "ca",
                    "ceb",
                    "ny",
                    "co",
                    "hr",
                    "cs",
                    "da",
                    "nl",
                    "eo",
                    "et",
                    "tl",
                    "fi",
                    "fr",
                    "fy",
                    "gl",
                    "ka",
                    "de",
                    "el",
                    "gu",
                    "ht",
                    "ha",
                    "haw",
                    "he",
                    "hi",
                    "hmn",
                    "hu",
                    "is",
                    "ig",
                    "id",
                    "ga",
                    "it",
                    "ja",
                    "jw",
                    "kn",
                    "kk",
                    "km",
                    "ko",
                    "ku",
                    "ky",
                    "lo",
                    "la",
                    "lv",
                    "lt",
                    "lb",
                    "mk",
                    "mg",
                    "ms",
                    "ml",
                    "mt",
                    "mi",
                    "mr",
                    "mn",
                    "my",
                    "ne",
                    "no",
                    "ps",
                    "fa",
                    "pl",
                    "pt",
                    "pa",
                    "ro",
                    "ru",
                    "sm",
                    "gd",
                    "sr",
                    "st",
                    "sn",
                    "sd",
                    "si",
                    "sk",
                    "sl",
                    "so",
                    "su",
                    "sw",
                    "sv",
                    "tg",
                    "ta",
                    "te",
                    "th",
                    "tr",
                    "uk",
                    "ur",
                    "uz",
                    "vi",
                    "cy",
                    "xh",
                    "yi",
                    "yo",
                    "zu"
                ],
                wrapper_selector: ".gtranslate_wrapper"
            };

            const script = document.createElement("script");
            script.src = "https://cdn.gtranslate.net/widgets/latest/dropdown.js";
            script.defer = true;
            document.body.appendChild(script);

            //Spanish url default automatically transalte to spanish
            const spanishUrls = (process.env.REACT_APP_SPANISH_URLS || "").split(",");
            if (spanishUrls.length > 0 && spanishUrls[0] !== "") {
                if (spanishUrls.some(url => window.location.href.includes(url))) {
                    document.cookie = "googtrans=/en/es; path=/";
                }
            }

            return () => {
                document.body.removeChild(script);
                delete window.gtranslateSettings;
            };
        }
    }, []);

    const toggleDropdown = () => {
        setDropdownVisible(!isDropdownVisible);
    };

    const handleClickOutside = useCallback(event => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownVisible(false);
        }
    }, []);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [handleClickOutside]);

    return (
        <div style={{ position: "relative" }} className="d-flex d-md-block" ref={dropdownRef}>
            {/* Icon to toggle the dropdown */}

            {iconMenu && (
                <IconNav
                    //label="Translate"
                    label={iconMenu.subheader}
                    handleClick={toggleDropdown}>
                    {/*<MdTranslate />*/}
                    {iconMenu.icon}
                </IconNav>
            )}

            {/* Dropdown wrapper */}
            <div
                id=".gtranslate_wrapper_element"
                className={`gtranslate_wrapper ${isDropdownVisible ? "visible" : "invisible"}`}></div>
        </div>
    );
};

export { GTranslate };
GTranslate.propTypes = {
    iconMenu: PropTypes.object.isRequired
};
